import { getMappedName } from "@/Utils/mapping-utils";

import { ChannelDataWithSourceAndTotal } from "../types";

/**
 * Helper function to get nicely formatted mapped channel names
 * @param channels - Array of channel data
 * @returns Array of channel data with mapped names
 */
export const getMappedChannelNames = (channels: ChannelDataWithSourceAndTotal[]) => {
  return channels.map((channel) => ({
    ...channel,
    mappedName: getMappedName(channel.mappedName) || channel.mappedName,
  }));
};
